import { AxiosInstance } from 'axios';
import { TaxGateway, CreateCalcTaxNFDto } from '../domain/tax.gateway';
import { CustomException } from '../../common/infra/error';

export class TaxHttpGateway implements TaxGateway {
    constructor(private http: AxiosInstance) {}

    async calcTaxNF(params: CreateCalcTaxNFDto): Promise<number> {
        try {
            const response = await this.http.post('/api/customer-portal/payments/CalcTaxNF', params, {
                timeout: 180000
            });
            return response.data;
        } catch (error: any) {
            throw new CustomException(error?.response?.data?.message || 'Erro ao calcular taxa');
        }
    }
}
